var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "block"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3333_11334",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3333_11334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "block_2",
    d: "M7.99984 15.0832C7.02206 15.0832 6.10262 14.8971 5.2415 14.5249C4.38039 14.1527 3.62762 13.6443 2.98317 12.9999C2.33873 12.3555 1.83317 11.6027 1.4665 10.7416C1.09984 9.88046 0.916504 8.95546 0.916504 7.96657C0.916504 6.9999 1.10262 6.08601 1.47484 5.2249C1.84706 4.36379 2.35261 3.61379 2.9915 2.9749C3.63039 2.33601 4.38039 1.83046 5.2415 1.45824C6.10262 1.08601 7.02206 0.899902 7.99984 0.899902C8.97762 0.899902 9.89706 1.08601 10.7582 1.45824C11.6193 1.83046 12.3693 2.33601 13.0082 2.9749C13.6471 3.61379 14.1554 4.36379 14.5332 5.2249C14.9109 6.08601 15.0998 6.9999 15.0998 7.96657C15.0998 8.95546 14.9137 9.88046 14.5415 10.7416C14.1693 11.6027 13.6609 12.3555 13.0165 12.9999C12.3721 13.6443 11.6193 14.1527 10.7582 14.5249C9.89706 14.8971 8.97762 15.0832 7.99984 15.0832ZM7.99984 13.5166C8.61106 13.5166 9.20556 13.4249 9.78334 13.2416C10.361 13.0582 10.8776 12.7666 11.3332 12.3666L3.59984 4.66657C3.23317 5.13324 2.95539 5.65085 2.7665 6.2194C2.57762 6.78796 2.48317 7.37035 2.48317 7.96657C2.48317 9.51513 3.01823 10.8273 4.08834 11.9031C5.15856 12.9787 6.46239 13.5166 7.99984 13.5166ZM12.3998 11.2832C12.7332 10.8166 13.0026 10.3 13.2082 9.7334C13.4137 9.16674 13.5165 8.57779 13.5165 7.96657C13.5165 6.44012 12.9814 5.14462 11.9113 4.08007C10.8412 3.01551 9.53739 2.48324 7.99984 2.48324C7.3925 2.48324 6.81012 2.5749 6.25267 2.75824C5.69523 2.94157 5.17762 3.21657 4.69984 3.58324L12.3998 11.2832Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.10b01742c86c47cd928657227916b64b.svg";
export { ForwardRef as ReactComponent };